import HomePage from "./components/pages/HomePage";
import NotFoundPage from "./components/pages/NotFoundPage";
import PanelLeftPage from "./components/pages/PanelLeftPage";
// INIT-GENERATOR.PHP importConfig
import HowItWorksPage from "./components/pages/HowItWorksPage";
import BattlesPage from "./components/pages/BattlesPage";
import UnboxigPage from "./components/pages/UnboxigPage";
// END-GENERATOR.PHP importConfig

export default [
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/panel-left/",
    component: PanelLeftPage,
  },
  // INIT-GENERATOR.PHP jsonConfig
  {
      path: "/how-it-work/",
      component: HowItWorksPage,
    },
  {
      path: "/battles/",
      component: BattlesPage,
    },
  {
      path: "/unboxing/",
      component: UnboxigPage,
    },
  // END-GENERATOR.PHP jsonConfig
  {
    path: "(.*)",
    component: NotFoundPage,
  },
];



// WEBPACK FOOTER //
// ./src/routes.ts